import { DateMeetingCard, Logo } from "../../atoms"
import { MessageCard } from "../../molecules/MessageCard"
import './DateMeetingMessage.css'

type DateMeetingProps = {
    date: string,
    isOld:boolean
}

export const DateMeetingMessage = ({ date }: DateMeetingProps) => {

    
    return (
        <MessageCard className="" fromSender={false}>
            <div className="d-flex  pt-1 pb-3 align-items-center">
                <Logo colorLogo={"white"} className={"match-logo me-2"} />
                <p className="p-0 m-0 fw-700"> Your match :</p>
            </div>
            <div className="d-flex flex-row justify-content-between ps-2 pe-2 cursor-disabled">
                <DateMeetingCard disabled={false}
                    date={date}
                    selectDate={() => { }} />
                    <div className="w-50">
                        <p className="p-0 m-0 "> Check your email to access the innovation meeting</p>
                    </div>
            </div>
        </MessageCard>
    )
}